import React from 'react'

import { List, Datagrid, TextField, EditButton } from 'react-admin'

const PlaceList = (props) => (
  <List {...props} exporter={false}>
    <Datagrid>
      <TextField source="name" label="Название" />
      <EditButton />
    </Datagrid>
  </List>
)

export default PlaceList
